import React, { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";

import { getPupilByClassId, getAssessmentByClassId } from "../../api/classesApi"
import * as commonApi from "../../api/commonApi";
import { NavigationBar, Subjects, Common } from "../../helper"
import { Header, LoadingSpinner } from "../../components/Shared";
import { ClassHomeCheckBox } from "./classHomeCheckBox.js"
import { ClassHomeBody } from "./classHomeBody.js"
import { UploadEvidences } from "./";
import { setSelect } from "../../store/stylesSlice.js";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../../App.scss";
import "../../assets/stlyes/ClassHome/ClassHome.scss";

// import ClassHomeTeam from "../../assets/images/ClassHomeTeam.svg"
import ClassHomeUploadIcon from "../../assets/images/ClassHomeUploadIcon.svg"

const ClassHome = () => {
  const dispatch = useDispatch();
  let isNavCollapsed = useSelector((state) => state.styleData.isNavCollapsed)
  const markingData = useSelector((state) => state.marking)
  const divRef = useRef(null);
  const [collapse, setCollapse] = useState(false)
  const [subjects, setSubjects] = useState([
    { subject: Subjects.Maths, isChecked: true },
    { subject: Subjects.Reading, isChecked: true },
    { subject: Subjects.Writing, isChecked: true },
    { subject: Subjects.Science, isChecked: true },
    { subject: Subjects.PE, isChecked: true }
  ]);
  const [classId, setClassId] = useState("")
  const [className, setClassName] = useState("")
  //   const [users, setUsers] = useState([])
  const [pupil, setPupil] = useState({})
  const [assessment, setAssessment] = useState([])
  const [year, setYear] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isStudentPage, setIsStudentPage] = useState(false);
  const [assmtAddDisable, setAassmtAddDisable] = useState();

  // const _getTeachersInClass = async (data) => {
  //   const response = await getTeachersInClass(data)
  //   setUsers(response.Items)
  // }

  const _getPupilByClassId = async (data) => {
    setIsLoading(true);
    const response = await getPupilByClassId(data)
    setPupil(response.Items[0])
    setIsLoading(false);
  }

  const _getAssessmentsByClassId = async (data) => {
    const response = await getAssessmentByClassId(data)
    setAssessment(response.Items)
  }

  useEffect(() => {
    const classId = markingData.classId, className = markingData.className, year = markingData.year
    setClassId(classId)
    setClassName(className)
    setYear(year)
    const data = { id: classId }
    // _getTeachersInClass(data);
    _getPupilByClassId(data)
    _getAssessmentsByClassId(data)
    getNavData(markingData.className)
  }, [markingData.classId, markingData.className, markingData.year])

  const getNavData = async (className) => {
    const _navigationbar = await commonApi.getNavBar({});
    let _class = _navigationbar && _navigationbar.Items.find(cls => cls.className === className)
    if ((_class?.subject.find(cls => cls.name === Subjects.Writing)) !== undefined) {
      setAassmtAddDisable(true)
    }
    else {
      setAassmtAddDisable(false)
    }
  }
  let subjectActualAverages = pupil?.subjectActualAverages
  let subjectPredictedAverages = pupil?.subjectPredictedAverages
  let subjectActualOutcomeAverages = pupil?.subjectActualOutcomeAverages
  let subjectPredictedOutcomeAverages = pupil?.subjectPredictedOutcomeAverages

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (divRef.current && !divRef.current.contains(event.target)) {
        handleOutsideClick();
      }
    };
    dispatch(setSelect(NavigationBar.ClassHome))

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOutsideClick = () => {
    setCollapse(false)
  };
  return (
    <div className="Page-layout">
      <div className="Page-header-classHome">
        <Header />
        {isLoading ? <LoadingSpinner /> : <div className="classHome-page" style={{ marginRight: isNavCollapsed ? "0px" : "150px" }}>
          <div className="classHome-header">
            <div className="classHome-title">
              <div className="myClasses-head-text">
                <div className={isNavCollapsed ? "main-ClassHeadFullScreen" : "main-ClassHead"}>
                  <div className="main-ClassHead-div" >
                    <div className="className"><span className="subClass">{className}</span><span className="classNameYearIcon">{year}</span></div>
                    <span className="performance">{Common.SubjectPerformanceSummary}</span>
                    {/* <label className="team"><img className='teamIcon' src={ClassHomeTeam} alt='teamIcon' />{users.map((u, k) =>
                        <React.Fragment key={k}>{k === users.length - 1 ? `${u.name}` : `${u.name}, `}</React.Fragment>)}
                      </label> */}
                  </div>
                  <div className="summary-dropdown" >
                    <button className="classHome-evidenceUpload" onClick={() => setIsOpen(true)}>{Common.UploadEvidenceforClass} <img src={ClassHomeUploadIcon} alt='ClassHomeUploadIcon' /></button>
                    <div id="summary-accordian" ref={divRef}>
                      <div className="accordion" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button"
                              type="button"
                              aria-controls="collapseOne"
                              onClick={() => setCollapse(!collapse)}
                            >
                              <span>{Common.PredictedPassRateTitle}</span>
                              <FontAwesomeIcon
                                icon={faChevronUp}
                                className={`accordion-icon ${collapse ? "rotate" : ""}`}
                              />
                            </button>
                          </h2>
                          {collapse && (
                            <div
                              id="collapseOne"
                              className="accordion-collapse collapse show"
                              data-bs-parent="#accordionExample"
                            >
                              <div className="accordian-body">
                                <ul>
                                  <li>
                                    <div id="accordianBodyMarker-bg-red"></div>
                                    <div id="accordianBodyMarker-bg-blue"></div>
                                    <div id="accordianBodyMarker-bg-violet"></div>
                                    {Subjects.Reading}, {Subjects.Writing}, {Subjects.Maths}
                                    <span>
                                      {subjectPredictedAverages && subjectPredictedAverages[Subjects.Maths] !== undefined
                                        ? Math.round(
                                          (subjectPredictedAverages[Subjects.Maths] +
                                            subjectPredictedAverages[Subjects.Reading] +
                                            subjectPredictedAverages[Subjects.Writing]) /
                                          3
                                        )
                                        : "0"}
                                      %
                                    </span>
                                  </li>
                                  {
                                    subjects.map(s => {
                                      switch (s.subject) {
                                      case Subjects.Reading:
                                        return <li><div id="accordianBodyMarker-bg-red"></div>{s.subject}<span>{subjectPredictedAverages && subjectPredictedAverages[s.subject] !== undefined ? subjectPredictedAverages[s.subject] : "0"}%</span></li>
                                      case Subjects.Writing:
                                        return <li><div id="accordianBodyMarker-bg-blue"></div>{s.subject}<span>{subjectPredictedAverages && subjectPredictedAverages[s.subject] !== undefined ? subjectPredictedAverages[s.subject] : "0"}%</span></li>
                                      case Subjects.Maths:
                                        return <li><div id="accordianBodyMarker-bg-violet"></div>{s.subject}<span>{subjectPredictedAverages && subjectPredictedAverages[s.subject] !== undefined ? subjectPredictedAverages[s.subject] : "0"}%</span></li>
                                      case Subjects.Science:
                                        return <li><div id="accordianBodyMarker-bg-green"></div>{s.subject}<span>{subjectPredictedAverages && subjectPredictedAverages[s.subject] !== undefined ? subjectPredictedAverages[s.subject] : "0"}%</span></li>
                                      case Subjects.PE:
                                        return <li><div id="accordianBodyMarker-bg-pink"></div>{s.subject}<span>{subjectPredictedAverages && (subjectPredictedAverages[s.subject] !== undefined ? subjectPredictedAverages[s.subject] : ((subjectPredictedAverages["PhysicalEducation"]) || subjectPredictedAverages[Subjects.PE])) || "0"}%</span></li>
                                      default:
                                      }
                                    })
                                  }
                                </ul>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  <ClassHomeCheckBox subjects={subjects} setSubjects={setSubjects} />
                </div>
                {isLoading ? <LoadingSpinner /> :
                  <ClassHomeBody subjects={subjects} {...pupil} assessment={assessment} subjectActualAverages={subjectActualAverages} subjectPredictedAverages={subjectPredictedAverages} subjectActualOutcomeAverages={subjectActualOutcomeAverages} subjectPredictedOutcomeAverages={subjectPredictedOutcomeAverages} className={className} assmtAddDisable={assmtAddDisable && assmtAddDisable} year={year} isNavCollapsed={isNavCollapsed} isLoading={isLoading} />
                }</div>
            </div>
          </div>
        </div>}
      </div>
      <Modal show={isOpen} onHide={() => { setIsOpen(false); }} backdrop="static" keyboard={false} id="upload-modal">
        <Modal.Header>

          {!isStudentPage && (
            <div>
              <span id="upload-header" style={{ fontSize: "22px", fontStyle: "normal", fontFamily: "Manrope", fontWeight: "700" }}>Upload Evidence</span>
              <span id="upload-header-span" style={{ color: "#011C25", fontSize: "12px", fontStyle: "normal", fontFamily: "Manrope", fontWeight: "400" }}>Select one or more subjects that are linked to the files you are uploading.</span>
            </div>
          )}

          {isStudentPage && (
            <div>
              <span id="upload-header" style={{ fontSize: "22px", fontStyle: "normal", fontFamily: "Manrope", fontWeight: "700" }}>Select students</span>
              <span id="upload-header-span" style={{ color: "#011C25", fontSize: "12px", fontStyle: "normal", fontFamily: "Manrope", fontWeight: "400" }}>Select the students for the evidence provided.</span>
            </div>
          )}
        </Modal.Header>
        <Modal.Body>
          <UploadEvidences setIsOpen={setIsOpen} classId={classId} setIsStudentPage={setIsStudentPage} />
        </Modal.Body>
      </Modal>
    </div>
  )
}

export { ClassHome };